module.exports = __webpack_public_path__ + "static/logo-icon-b77ae9cb1bcbdba16a2c661a8ddcea47.png";